import { render, staticRenderFns } from "./MyPayments.vue?vue&type=template&id=5f53a221&scoped=true&"
import script from "./MyPayments.vue?vue&type=script&lang=js&"
export * from "./MyPayments.vue?vue&type=script&lang=js&"
import style0 from "./MyPayments.vue?vue&type=style&index=0&id=5f53a221&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53a221",
  null
  
)

export default component.exports